import {BasicEntity} from '../../framework/message/BasicEntity';

export class EMPackEntry {
businessUnitCode: string;
domain: string;
entity: BasicEntity;
entityClass: string;
entityUID: string;
operation: string;
packUID: string;
}

